import { render } from "./AdminBoxNotifications.vue?vue&type=template&id=5713d6e4&scoped=true"
import script from "./AdminBoxNotifications.vue?vue&type=script&lang=js"
export * from "./AdminBoxNotifications.vue?vue&type=script&lang=js"

import "./AdminBoxNotifications.vue?vue&type=style&index=0&id=5713d6e4&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5713d6e4"]])

export default __exports__